import type { LobbyState } from './lobbyStore.types';

export const latencySlice: Pick<
  LobbyState,
  | 'isWaitingForResponse'
  | 'requestSentAt'
  | 'ttftLatency'
  | 'totalLlmLatency'
  | 'streamStartedAt'
  | 'partyTyping'
  | 'setWaitingForResponse'
> = {
  isWaitingForResponse: true,
  requestSentAt: null,
  ttftLatency: null,
  totalLlmLatency: null,
  streamStartedAt: null,
  partyTyping: {},

  setWaitingForResponse: (waiting: boolean) => ({
    isWaitingForResponse: waiting,
    requestSentAt: waiting ? Date.now() : null,
  }),
};
